import {ExportColumn} from "../MakeSubmittal";
import React from "react";
import {useReadyCheck} from "../../../../../misc/pdf/UseReadyCheck";
import {Div10Row} from "../../../../../api/QuoteDiv10";
import {PdfTableServerRendered} from "../../openings/pdf/PdfTableServerRendered";

export function RowsPage(props: {
    data: Div10Row[]
    columns: ExportColumn[]
    onReady(): void;
}) {

    const ready = useReadyCheck(props.onReady);
    ready.require(true);

    return (<>
        <PdfTableServerRendered value={{
            header: props.columns.map(c => c.display),
            content: props.data.map(d => props.columns.map(c => {
                if(c.render) {
                    return c.render(d).toString()
                }

                return d[c.key]?.toString() || ""
            }))
        }} />
    </>)
}